"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var Box_1 = __importDefault(require("./Box"));
var icons_1 = require("../icons");
var Radio = function (_a) {
    var checked = _a.checked, disabled = _a.disabled, size = _a.size, rest = __rest(_a, ["checked", "disabled", "size"]);
    var radioSize = (size || 24) + 4;
    return (react_1["default"].createElement(RadioWrap, { checked: checked, disabled: disabled },
        react_1["default"].createElement(RadioInput, __assign({ type: "radio", role: "radio" }, rest, { checked: checked, disabled: disabled })),
        react_1["default"].createElement(RadioIcon, { checked: checked, size: radioSize })));
};
var RadioWrap = styled_components_1["default"](Box_1["default"])(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-block;\n  color: ", ";\n  cursor: pointer;\n\n  &:hover > svg {\n    path {\n      ", ";\n    }\n  }\n"], ["\n  display: inline-block;\n  color: ", ";\n  cursor: pointer;\n\n  &:hover > svg {\n    path {\n      ",
    ";\n    }\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.text;
}, function (_a) {
    var disabled = _a.disabled, checked = _a.checked, theme = _a.theme;
    if (checked && !disabled) {
        return "fill: " + theme.colors.primary + " !important;";
    }
    return disabled ? null : "fill: " + theme.colors.primary + ";";
});
var RadioInput = styled_components_1["default"].input(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  appearance: none;\n  opacity: 0;\n  position: absolute;\n  z-index: 0;\n  & ~ svg {\n    border: 1px solid transparent;\n    border-radius: 50%;\n    padding: 2px;\n  }\n  &:focus {\n    box-shadow: none;\n    & ~ svg {\n      border: 1px solid ", ";\n      background-color: ", ";\n    }\n  }\n  &:checked ~ svg {\n    path {\n      fill: ", ";\n    }\n  }\n  &:disabled ~ svg {\n    path {\n      fill: ", ";\n    }\n  }\n"], ["\n  appearance: none;\n  opacity: 0;\n  position: absolute;\n  z-index: 0;\n  & ~ svg {\n    border: 1px solid transparent;\n    border-radius: 50%;\n    padding: 2px;\n  }\n  &:focus {\n    box-shadow: none;\n    & ~ svg {\n      border: 1px solid ", ";\n      background-color: ", ";\n    }\n  }\n  &:checked ~ svg {\n    path {\n      fill: ", ";\n    }\n  }\n  &:disabled ~ svg {\n    path {\n      fill: ", ";\n    }\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.primary;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.white;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.black;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.borderGray;
});
var RadioCheckedIcon = styled_components_1["default"](icons_1.RadioChecked)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  vertical-align: middle;\n"], ["\n  vertical-align: middle;\n"])));
var RadioEmptyIcon = styled_components_1["default"](icons_1.RadioEmpty)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  vertical-align: middle;\n"], ["\n  vertical-align: middle;\n"])));
var RadioIcon = function (_a) {
    var checked = _a.checked, size = _a.size;
    return checked ? (react_1["default"].createElement(RadioCheckedIcon, { size: size })) : (react_1["default"].createElement(RadioEmptyIcon, { size: size }));
};
Radio.displayName = 'Radio';
exports["default"] = Radio;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=Radio.js.map